import { render } from "./Footer.vue?vue&type=template&id=0313e9db"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/footer/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0313e9db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0313e9db', __exports__)) {
    api.reload('0313e9db', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=0313e9db", () => {
    api.rerender('0313e9db', render)
  })

}


export default __exports__